import { Typography } from '@mui/material';
import React from 'react';

function BasicError({ error, sx = {} }) {
    return error !== '' && (
        <Typography variant="overline" sx={{ color: 'error.light', textAlign: 'center', fontWeight: 600, ...sx }}>
            {error}
        </Typography>
    );
}
export default BasicError;